import { useState, useEffect } from 'react';
import axios from 'axios';
import routes from 'app/routes';

export default function usePlan(enterpriseId, planId) {
  const [loading, setLoading] = useState(true);
  const [plan, setPlan] = useState(null);

  useEffect(() => {
    axios
      .get(
        routes.api.policy_plans.show(planId),
        { params: { enterprise_id: enterpriseId } },
      )
      .then((resp) => {
        setLoading(false);
        setPlan(resp.data.data);
      });
  }, []);

  return { loading, plan };
}
